import React, { useEffect, useState } from 'react';
import PeriodBar, { usePeriod } from '../components/PeriodBar';

export default function Reports() {
  const [allClasses, setClasses] = useState([]);
  const period = usePeriod();   // 今の期間の授業だけ【2026-09-17】
  const classes = period.filter(Array.from(new Map(allClasses.map(c => [c.id, c])).values()));
  const [classId, setClassId] = useState('');
  const [start, setStart]     = useState('');
  const [end, setEnd]         = useState('');
  const [busy, setBusy]       = useState(false);
  const [msg, setMsg]         = useState('');
  const [err, setErr]         = useState('');

  useEffect(() => {
    if (!period.ready) return;
    const token = localStorage.getItem('token');
    fetch('/api/schedule/classes?includeClosed=1' + (period.year ? '&academicYear=' + period.year : ''),
          { headers: { Authorization: 'Bearer ' + token } })
      .then(r => r.json())
      .then(d => setClasses(d.classes || d.data || []))
      .catch(() => {});
  }, [period.ready, period.year]);

  const download = async (kind) => {
    if (!classId) { setErr('授業を選択してください'); return; }
    setBusy(true); setErr(''); setMsg('');
    try {
      const token  = localStorage.getItem('token');
      const params = new URLSearchParams();
      if (start) params.append('startDate', start);
      if (end)   params.append('endDate', end);
      const url    = '/api/reports/class/' + classId + '/' + kind +
                     (params.toString() ? '?' + params.toString() : '');
      const res    = await fetch(url, { headers: { Authorization: 'Bearer ' + token } });
      if (!res.ok) {
        const text = await res.text();
        throw new Error('HTTP ' + res.status + ' ' + text.slice(0, 200));
      }
      const blob   = await res.blob();
      const objUrl = URL.createObjectURL(blob);
      const a      = document.createElement('a');
      a.href       = objUrl;
      const prefix = kind === 'pdf' ? 'report_' : 'attendance_';
      a.download   = prefix + classId + '_' + new Date().toISOString().slice(0,10) + '.' + kind;
      document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(objUrl);
      setMsg('ダウンロードを開始しました ');
    } catch (e) { setErr(e.message); }
    finally     { setBusy(false); }
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>レポート出力</h1>
        <p>授業ごとの出席記録をCSVまたはPDFでダウンロードできます。</p>
      </div>

      <div className="card">
        <div className="card-header"><h2>条件指定</h2></div>

        <div className="form-row">
          <label>授業 *</label>
          <PeriodBar period={period} />
          <select value={classId} onChange={e => setClassId(e.target.value)}>
            <option value="">— 選択してください —</option>
            {classes.map(c => (
              <option key={c.id} value={c.id}>{c.name}{c.semester ? ' (' + c.semester + ')' : ''}</option>
            ))}
          </select>
        </div>

        <div className="form-row">
          <label>期間（オプション）</label>
          <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
            <input type="date" value={start} onChange={e => setStart(e.target.value)}/>
            <span>〜</span>
            <input type="date" value={end}   onChange={e => setEnd(e.target.value)}/>
          </div>
          <small style={{ color: '#888' }}>未指定の場合、全期間が対象になります</small>
        </div>

        <div style={{ display: 'flex', gap: '0.5rem', marginTop: '1rem', flexWrap: 'wrap' }}>
          <button className="btn-primary" onClick={() => download('xlsx')} disabled={busy}>
            Excel (.xlsx) をダウンロード
          </button>
          <button className="btn-secondary" onClick={() => download('csv')} disabled={busy}>
            CSVをダウンロード
          </button>
          <button className="btn-secondary" onClick={() => download('pdf')} disabled={busy}>
            PDFをダウンロード
          </button>
        </div>

        {busy && <p style={{ marginTop: '1rem', color: '#666' }}>処理中...</p>}
        {msg  && <p style={{ marginTop: '1rem', color: '#166534' }}>{msg}</p>}
        {err  && <p style={{ marginTop: '1rem', color: '#c62828' }}>{err}</p>}
      </div>

      <div className="card" style={{ background: '#f9fafb' }}>
        <div className="card-header"><h2>ヒント</h2></div>
        <ul style={{ paddingLeft: '1.5rem', lineHeight: 1.9 }}>
          <li><strong>Excel (.xlsx)</strong>: 罫線・色付き・出席率の自動色分け付き。普段使いはこちら</li>
          <li><strong>CSV</strong>: 軽量。他システムへの取り込みや一括加工向け（UTF-8 BOM付き）</li>
          <li><strong>PDF</strong>: 月次レポート用にレイアウト済み。印刷・配布向け</li>
          <li>大量データの場合、生成に数秒かかることがあります</li>
        </ul>
      </div>
    </div>
  );
}
